module.exports = __webpack_public_path__ + "static/media/list-ol.1e1e3627.svg";